import { render, staticRenderFns } from "./SlotBasedSelect.vue?vue&type=template&id=248f2a16&"
import script from "./SlotBasedSelect.vue?vue&type=script&lang=js&"
export * from "./SlotBasedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports